import {Component} from '@angular/core';

@Component({
	selector: 'message-board-placeholder',
	template: `
    <div class="ph-item">
      <div class="ph-col-2">
        <div class="ph-avatar"></div>
      </div>
      <div>
        <div class="ph-row">
          <div class="ph-col-12 big"></div>
          <div class="ph-col-2"></div>
        </div>
      </div>
      <div class="ph-col-12">
        <div class="ph-row">
          <div class="ph-col-12"></div>
          <div class="ph-col-8"></div>
          <div class="ph-col-12"></div>
          <div class="ph-col-4"></div>
        </div>
      </div>
      <div class="ph-col-12">
        <div class="ph-row">
          <div class="ph-col-12 big empty"></div>
          <div class="ph-col-4 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-4 big"></div>
        </div>
        <div class="ph-row">
          <div class="ph-col-4"></div>
          <div class="ph-col-4 empty"></div>
          <div class="ph-col-4"></div>
        </div>
      </div>
    </div>
	`,
})
export class MessageBoardPostPlaceholderComponent {

}
